import { Link as BaseLink } from '@tiptap/extension-link';

// Page links retain their page id so supported renderers can refresh the href
// after a rename; the stored href remains the fallback everywhere else.
export const Link = BaseLink.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      internalPageId: {
        default: null,
        parseHTML: (element) => element.getAttribute('data-internal-page-id'),
        renderHTML: (attributes) =>
          attributes.internalPageId ? { 'data-internal-page-id': attributes.internalPageId } : {},
      },
    };
  },
});
